import { Vector2 } from '@babylonjs/core/Maths/math';
import { _camera, _contentsManager, _system } from '~/Services/Studio/studioScene';
import { UiPointer } from '~/Scene/Ui/uiPointer';

export class CanvasInteraction {
    uiPointer: UiPointer;

    constructor() {
        this.uiPointer = new UiPointer(_system.canvas);
    }

    public startInteraction(): void {
        _contentsManager.playContent(true);
        _camera.followMove(Vector2.Zero());
        _camera.setEditorControl(false);
        this.setDraggable(true);
    }

    public setFreeMode(): void {
        this.stopInteraction();
        _camera.setEditorControl(true);
        this.uiPointer.setDraggable(true);
        _system.resetShadows();
    }

    public stopInteraction(): void {
        _contentsManager.playContent(false);
        _camera._setFollowMouseSensibility(new Vector2(0.5, 0.5));
        this.setDraggable(false);
        _system.resetShadows();
    }

    private setDraggable(draggable: boolean) {
        _camera._setDraggableSensibility(new Vector2(0.5, 0.5));
        this.uiPointer.setDraggable(draggable);
    }
}

export const canvasInteraction = new CanvasInteraction();
